import React from "react";

export default function SubscribePage({ title }) {
  return (
    <div className="signup center">
      <h1>{title ? title : "Thanks for voting!"}</h1>
      <p>
        Click{" "}
        <a href="https://docs.google.com/spreadsheets/d/1_CeovpvuXEseusS1sRAGL3nxUvbqydGKg-vmLlaRIpA/edit?usp=sharing">
          here
        </a>{" "}
        to see the raw results. Subscribe below to receive an analysis of the
        results and an invite to a panel discussion about what this implies
        about each of these voting methods.
      </p>

      <div id="signup">
        <form
          action="https://app.us10.list-manage.com/subscribe/post?u=4af28b4437ca4bd915170617f&amp;id=33d002689e"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          target="_blank"
          noValidate
        >
          <div>
            <input
              type="email"
              name="EMAIL"
              className="email"
              id="mce-EMAIL"
              placeholder="email address"
              required
            />
            <br />
            <br />
            <div class="mc-field-group input-group">
              <strong>Interests</strong>
              <br />
              <input
                type="checkbox"
                defaultChecked={true}
                value="1"
                name="group[19081][1]"
                id="mce-group[19081]-19081-0"
              />
              <label for="mce-group[19081]-19081-0">
                Send me the election result analysis
              </label>
              <br />
              <input
                type="checkbox"
                value="2"
                name="group[19081][2]"
                id="mce-group[19081]-19081-1"
              />
              <label for="mce-group[19081]-19081-1">
                Send me occasional updates on alternative voting news
              </label>
              <br />
              <input
                type="checkbox"
                value="4"
                name="group[19081][4]"
                id="mce-group[19081]-19081-2"
              />
              <label for="mce-group[19081]-19081-2">
                I'm interested in helping improve this site
              </label>
              <br />
              <br />
            </div>
            <div
              style={{
                position: "absolute",
                left: "-5000px",
                ariaHidden: "true"
              }}
            >
              <input
                type="text"
                name="b_4af28b4437ca4bd915170617f_33d002689e"
                tabIndex="-1"
                defaultValue=""
              />
            </div>
            <input
              type="submit"
              value="Subscribe"
              name="subscribe"
              id="mc-embedded-subscribe"
              className="button"
            />
          </div>
        </form>
      </div>
      <p className="smallcap">
        <i>
          We promise to keep your email secure, not disclose it to third parties
          and not to spam you.
          <br />
          You may unsubscribe at any time.
        </i>
      </p>
    </div>
  );
}
